export default __webpack_public_path__ + "static/media/axfina_logo_long_white.997e23c1.svg";